import React from 'react';
import { Link } from 'react-router-dom';
import { Button, makeStyles } from '@material-ui/core';

const Activity = () => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'block',
      margin: '0 170px 0 70px'
    },
    link: {
      color: 'black',
      textTransform: 'capitalize'
    }
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Button>
          <Link to='/activities' className={classes.link}>
            All Activities
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default Activity;



// WEBPACK FOOTER //
// ./src/components/SideBars/Activity.js